import { Josefin_Sans } from "next/font/google";
import Image from "next/image";
import classesImg from "../img/classes.webp";
import eventsImg from "../img/events.webp";
import { useState } from "react";
import Link from "next/link";

const josefinSans = Josefin_Sans({ subsets: ["latin"], weight: "400" });

function formatDateAmerican(dateString) {
  if (!dateString) return "";

  const parts = dateString.split("-");
  if (parts.length !== 3) return dateString;

  const year = parseInt(parts[0]);
  const month = parseInt(parts[1]);
  const day = parseInt(parts[2]);

  const date = new Date(year, month - 1, day); // Note: month is 0-indexed
  return `${month}/${day}/${year}`;
}

export default function InfoCard({
  eventId,
  imgUrl,
  infoTitle,
  startDate,
  endDate,
  description,
  type,
  scheduleStatus,
  ongoing,
}) {
  const [imgSrc, setImgSrc] = useState(imgUrl);
  const [showFullDescription, setShowFullDescription] = useState(false);
  const fallbackSrc = type.toLowerCase() === "class" ? classesImg : eventsImg;
  const formattedStart = formatDateAmerican(startDate);
  const formattedEnd = formatDateAmerican(endDate);

  const dateDisplay = formattedEnd
    ? `${formattedStart} - ${formattedEnd}`
    : formattedStart;

  return (
    <div
      className={`${
        josefinSans.className
      } flex flex-col justify-between h-full flex flex-col text-center px-8 rounded-xl my-2 md:my-8 py-8 bg-cardYellow break-words whitespace-pre-wrap ${
        scheduleStatus?.toLowerCase() === "cancelled"
          ? "opacity-90 grayscale"
          : ""
      }`}
    >
      <div className="relative w-[90%] h-64 mx-auto mb-6 rounded-xl overflow-hidden">
        <Image
          src={imgSrc || fallbackSrc}
          onError={() => setImgSrc(fallbackSrc)}
          alt={infoTitle || "Info image"}
          fill
          style={{ objectFit: "cover", borderRadius: "inherit" }}
        />
      </div>

      <h1 className="text-2xl">{infoTitle}</h1>
      <h3 className="text-base">{dateDisplay}</h3>

      <div className="relative">
        {ongoing && (
          <p className="text-sm font-semibold uppercase tracking-wide text-green-800 bg-green-100 inline-block px-3 py-1 rounded-full my-2">
            Ongoing
          </p>
        )}

        {scheduleStatus?.toLowerCase() === "cancelled" && (
          <p className="text-lg font-bold uppercase text-red-700 tracking-wide my-2">
            Cancelled
          </p>
        )}

        {scheduleStatus?.toLowerCase() === "postponed" && (
          <p className="text-lg font-semibold uppercase text-red-700 tracking-wide my-2">
            Postponed
          </p>
        )}
        <p
          className={`md:text-lg py-2 break-words whitespace-pre-wrap transition-all duration-300 ease-in-out ${
            showFullDescription ? "max-h-full" : "max-h-[100px] overflow-hidden"
          }`}
        >
          {description}
        </p>
        <div className="mt-6">
          <button
            href={`./listing?eventId=${eventId}&eventType=${type}`}
            className="px-6 py-3 bg-white hover:bg-gray-200 rounded-lg"
          >
            Learn More
          </button>
        </div>
      </div>
    </div>
  );
}
